const articles = window.backerSparkArticles || [];
const params = new URLSearchParams(window.location.search);
const slug = params.get("slug");

const articleCount = document.querySelector("#articleCount");
const blogList = document.querySelector(".blog-list-section");
const grid = document.querySelector("#blogArticleGrid");
const articlePage = document.querySelector("#articlePage");
const relatedSection = document.querySelector("#relatedSection");
const title = document.querySelector("#articleTitle");
const summary = document.querySelector("#articleSummary");
const category = document.querySelector("#articleCategory");
const readTime = document.querySelector("#articleReadTime");
const content = document.querySelector("#articleContent");
const related = document.querySelector("#relatedArticles");

const renderParagraphs = (body) => {
  const paragraphs = Array.isArray(body) ? body : [body];
  return paragraphs.map((paragraph) => `<p>${paragraph}</p>`).join("");
};

const renderBullets = (bullets) => {
  if (!bullets?.length) return "";
  return `
    <ul>
      ${bullets.map((bullet) => `<li>${bullet}</li>`).join("")}
    </ul>
  `;
};

const cardMarkup = (article, index = 1) => `
  <a
    class="article-card article-link-card${index === 0 ? " is-featured" : ""}"
    href="/blogs/news?slug=${article.slug}"
    aria-label="Read ${article.title}"
  >
    <div class="article-meta">
      <span>${article.category}</span>
      <span>${article.readTime}</span>
    </div>
    <h3>${article.title}</h3>
    <p>${article.summary}</p>
    <span class="read-more">Read article</span>
  </a>
`;

if (articleCount) {
  articleCount.textContent = `${articles.length} articles`;
}

if (!slug) {
  if (grid) {
    grid.innerHTML = articles.map(cardMarkup).join("");
  }
} else {
  const article = articles.find((item) => item.slug === slug) || articles[0];
  if (blogList) blogList.hidden = true;
  if (articlePage) articlePage.hidden = false;
  if (relatedSection) relatedSection.hidden = false;

  if (article) {
    document.title = `${article.title} | BackerSky Blog`;
    title.textContent = article.title;
    summary.textContent = article.summary;
    category.textContent = article.category;
    readTime.textContent = article.readTime;
    content.innerHTML = article.sections
      .map(
        (section) => `
          <section>
            <h2>${section.heading}</h2>
            ${renderParagraphs(section.body)}
            ${renderBullets(section.bullets)}
          </section>
        `,
      )
      .join("");

    related.innerHTML = articles
      .filter((item) => item.slug !== article.slug)
      .slice(0, 3)
      .map((item) => cardMarkup(item))
      .join("");
  }
}
